import { SimpleGrid, Paper, Text, Group } from '@mantine/core';
import { IconBuilding, IconCoin, IconChartBar } from '@tabler/icons-react';
import { useCompanies } from '@/hooks/useCompanies';
import { useTokenHistory } from '@/hooks/useTokens';
import { useRevenue } from '@/hooks/useRevenue';
import { formatCurrency } from '@/utils/format';

export function CompanyStats() {
  const { data: companies } = useCompanies();
  const { data: tokenHistory } = useTokenHistory();
  const { data: revenue } = useRevenue();

  const totalCompanies = companies?.length ?? 0;

  const tokensThisMonth = tokenHistory?.filter((t) => {
    const eventDate = new Date(t.sentAt);
    const now = new Date();
    return eventDate.getMonth() === now.getMonth() && eventDate.getFullYear() === now.getFullYear();
  }).reduce((sum, t) => sum + t.tokenCount, 0) ?? 0;

  const totalRevenue = revenue?.reduce((sum, r) => sum + r.totalRevenue, 0) ?? 0;

  const stats = [
    { label: 'Unternehmen', value: totalCompanies.toString(), icon: IconBuilding, color: 'blue' },
    { label: 'Tokens (diesen Monat)', value: tokensThisMonth.toString(), icon: IconCoin, color: 'teal' },
    { label: 'Gesamtumsatz', value: formatCurrency(totalRevenue), icon: IconChartBar, color: 'grape' },
  ];

  return (
    <SimpleGrid cols={{ base: 1, sm: 3 }}>
      {stats.map((stat) => (
        <Paper key={stat.label} withBorder p="md" radius="md">
          <Group justify="space-between">
            <div>
              <Text size="xs" c="dimmed" tt="uppercase" fw={700}>
                {stat.label}
              </Text>
              <Text fw={700} size="xl">
                {stat.value}
              </Text>
            </div>
            <stat.icon size={32} color={`var(--mantine-color-${stat.color}-6)`} stroke={1.5} />
          </Group>
        </Paper>
      ))}
    </SimpleGrid>
  );
}
